import React from 'react';
import theme from '../../theme';
import { IconProps } from './props'

const BackIcon: React.FC<IconProps> = ({ id, iconColor = theme.textDark, ...rest }) => (
    <svg
        id={id}
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...rest}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.53125 12C4.53125 11.4477 4.97897 11 5.53125 11H19.5312C20.0835 11 20.5312 11.4477 20.5312 12C20.5312 12.5523 20.0835 13 19.5312 13H5.53125C4.97897 13 4.53125 12.5523 4.53125 12Z"
            fill={iconColor} />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.2384 4.29289C13.6289 4.68342 13.6289 5.31658 13.2384 5.70711L6.94546 12L13.2384 18.2929C13.6289 18.6834 13.6289 19.3166 13.2384 19.7071C12.8478 20.0976 12.2147 20.0976 11.8241 19.7071L4.82414 12.7071C4.43362 12.3166 4.43362 11.6834 4.82414 11.2929L11.8241 4.29289C12.2147 3.90237 12.8478 3.90237 13.2384 4.29289Z"
            fill={iconColor} />
    </svg>
);

export { BackIcon };